import { render, staticRenderFns } from "./CargoCreate.vue?vue&type=template&id=a352aeec"
import script from "./CargoCreate.vue?vue&type=script&lang=js"
export * from "./CargoCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports